import mutations from './mutations'
// import actions from './actions'

const state = {
    searchphone: '',
};


export default {
    state,
    mutations
}